/**
 * @generated SignedSource<<ffb5e7610e86c8bb03e21d546050a57d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectRowSummary_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PlannerLeftColumn_user">;
  readonly " $fragmentType": "ProjectRowSummary_user";
};
export type ProjectRowSummary_user$key = {
  readonly " $data"?: ProjectRowSummary_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRowSummary_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectRowSummary_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlannerLeftColumn_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "dd5972e4cacf5ab41bfae248940e8727";

export default node;
